module.exports = __webpack_public_path__ + "static/battle04-sq-f0fbce4795aaee25cd47b765207f9a3b.png";